module.exports = __webpack_public_path__ + "static/media/little_mac.9b1eafbb.png";